@if (params$ | async; as params) {
	@if (self$ | async; as self) {
		@if (!isValidVersion(self)) {
			<div class="information">
				<p class="information-text">
					<i class="ico ico-warning"></i><span translate="process.usergroups.edit.information"></span>
				</p>
			</div>
		}
		<ng-template #itemTemplate let-item>
			<a
				class="label"
				[routerLink]="[
					'/',
					'workspace',
					params.get('workspaceId'),
					params.get('processVersion'),
					{ outlets: { primary: ['administration', 'usergroups', item.userGroupId, 'roles'] } },
				]"
			>
				<div class="text center">
					<span class="h4">{{ item.name }}</span>
					@if (item.alreadyAdded) {
						<p
							class="error"
							translate="process.element.usergroupassignments.alreadyAdded"
							[translateParams]="{ user: item.creator.fullname, date: item.creationDate }"
						></p>
					}
				</div>
			</a>
			<stages-menu
				menuId="ugrp{{ item.id }}"
				[noCollapse]="true"
				class="action"
				iconClasses="ico ico-more-vertical"
				openTo="left"
				[items]="menuItems"
				[context]="item"
			/>
		</ng-template>
		<ng-template #autoCompleteTemplate let-userGroup>
			<div class="item">
				<div class="label">
					<span class="h4">{{ userGroup.name }}</span>
				</div>
			</div>
		</ng-template>
		<stages-responsive-data-view
			#dataView
			[dataSource]="dataSource"
			[listItemTemplate]="itemTemplate"
			[translateNone]="translateNone"
			[autoCompleteTemplate]="autoCompleteTemplate"
			[idFn]="UserGroupsComponent.getId"
			[disabledFn]="UserGroupsComponent.isDisabled"
			[showMore]="true"
			[pageSize]="pageSize"
			listStyles="list dense"
		/>
	}
}
